import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconMaximize = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 7.33333C5 6.04467 6.04467 5 7.33333 5H9.33333C9.88562 5 10.3333 5.44772 10.3333 6C10.3333 6.55228 9.88562 7 9.33333 7H7.33333C7.14924 7 7 7.14924 7 7.33333V9.33333C7 9.88562 6.55228 10.3333 6 10.3333C5.44772 10.3333 5 9.88562 5 9.33333V7.33333ZM13.6667 6C13.6667 5.44772 14.1144 5 14.6667 5H16.6667C17.9553 5 19 6.04467 19 7.33333V9.33333C19 9.88562 18.5523 10.3333 18 10.3333C17.4477 10.3333 17 9.88562 17 9.33333V7.33333C17 7.14924 16.8508 7 16.6667 7H14.6667C14.1144 7 13.6667 6.55228 13.6667 6ZM18 13.6667C18.5523 13.6667 19 14.1144 19 14.6667V16.6667C19 17.9553 17.9553 19 16.6667 19H14.6667C14.1144 19 13.6667 18.5523 13.6667 18C13.6667 17.4477 14.1144 17 14.6667 17H16.6667C16.8508 17 17 16.8508 17 16.6667V14.6667C17 14.1144 17.4477 13.6667 18 13.6667ZM6 13.6667C6.55228 13.6667 7 14.1144 7 14.6667V16.6667C7 16.8508 7.14924 17 7.33333 17H9.33333C9.88562 17 10.3333 17.4477 10.3333 18C10.3333 18.5523 9.88562 19 9.33333 19H7.33333C6.04467 19 5 17.9553 5 16.6667V14.6667C5 14.1144 5.44772 13.6667 6 13.6667Z"
        />
      </svg>
    );
  }
);
